import type { CellData, ColumnDef, RowData } from '@tanstack/react-table';

import { DATA_TABLE_ROW_DRAG_COLUMN_ID } from '../../constants.js';
import type { TDataTableFeatures } from '../types/features.types.js';

/**
 * Helper function to identify the row drag column.
 * @internal
 */
export function isRowDragColumnDef<
  TData extends RowData,
  TValue extends CellData = CellData,
>(column: ColumnDef<TDataTableFeatures, TData, TValue>): boolean {
  return column.id === DATA_TABLE_ROW_DRAG_COLUMN_ID;
}
